module.exports = __webpack_public_path__ + "static/media/AugustaMargaretRiverTimes-devicecomp-min.c8cb6960.webp";